<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('allergy_note') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-6
      v-row.mb-0(no-gutters)
        v-col
          .font-bold.neutral500--text.text-uppercase.text-sm {{ $t('allergy') }}
        v-col
          .font-bold.neutral500--text.text-uppercase.text-sm {{ $t('reaction') }}
      v-divider.mb-2
      .pb-4
        template(v-for="(allergy, index) in selectedAllergies")
          v-row.mb-2(no-gutters)
            v-col
              v-text-field.round-xl.mr-2(v-model="allergy.name" placeholder="Type allergy name" outlined hide-details dense)
            v-col
              .d-flex.align-center
                v-text-field.round-xl(v-model="allergy.reaction" placeholder="Reaction to allergy" outlined hide-details dense)
                v-btn(icon color="primary")
                  v-icon(@click="removeAllery(index)" size="18") $yzi-trash-03
      div
      v-btn.button-sm.underline.px-0(@click="addAllergy" text) {{ $t('add_allergy') }}
    v-divider

    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="save" :loading="isLoading" color="primary" depressed) {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import clone from 'just-clone'

export default {
  name: 'EditAllergyDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    allergies: {
      type: Array,
      default: () => []
    },
    patientId: {
      type: Number,
      required: true,
    }
  },
  data: () => ({
    isLoading: false,
    selectedAllergies: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.allergies && this.allergies.length > 0) {
      this.selectedAllergies = clone(this.allergies)
    } else {
      this.addAllergy()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    addAllergy () {
      this.selectedAllergies.push({ name: '', reaction: '' })
    },
    removeAllery (index) {
      this.selectedAllergies.splice(index, 1)
      if (this.selectedAllergies.length === 0) {
        this.addAllergy()
      }
    },
    save () {
      this.isLoading = true
      const params = {
        allergies: this.selectedAllergies.filter(item => item.name !== "")
      }
      this.$axios.patch(`/clinics/${this.company.slug}/patients/${this.patientId}/record`, params)
        .then(resp => {
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
          this.$emit('updated', resp.data.allergies)
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
